import React, {useEffect, useReducer} from "react";
import {connect} from "react-redux";
import {Spinner} from "react-bootstrap";
import {Redirect} from "react-router-dom";
import {Button, Card, Col, Container, Form, Row} from "@deere/ux.uxframe-react";
import {saveCutRegistration} from "../../redux/components/cutRegistration/cutRegistrationAction";
import {getCountries} from "../../redux/components/countriesList/countriesAction";
import {getStates} from "../../redux/components/statesList/statesAction";
import {validatePostalCode} from "../../redux/components/postalCode/postalCodeAction";
import {validatePin} from "../../redux/components/pinValidation/pinValidationAction";
import {resetFormAction} from "../../redux/components/shared/resetFormAction";
import {
    amountOfUseValidator,
    pinValidator,
    postalCodeApiValidator,
    postalCodeCountryValidator,
} from "./RegistrationRequestValidation"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CUTs_img from "../../CUTs_image.jpg";
import "./RegistrationRequest.css"

const mapStateToProp = (state, ownProp) => {

    return {
        registrationDetail: state.registrationDetail,
        countriesDetail: state.countriesDetail,
        statesDetail: state.statesDetail,
        pinValidationDetail: state.pinValidationDetail,
        postalCodeDetail: state.postalCodeDetail
    }
}

const mapDispatchToProps = dispatch => {
    return {
        resetForm: () => dispatch(resetFormAction()),
        submitRegistration: regFormData => dispatch(saveCutRegistration(regFormData)),
        getCountries: () => dispatch(getCountries()),
        getStatesList: (countryCode, locale) => dispatch(getStates(countryCode, locale)),
        validatePostalCodeData: (postalCodeData) => dispatch(validatePostalCode(postalCodeData)),
        validatePin: (serialNumber) => dispatch(validatePin(serialNumber))
    }
}

const initialFormDetails = {
    "firstName": "",
    "lastName": "",
    "companyName": "",
    "emailAddress": "",
    "phone": "",
    "businessIndicator": "I",
    "streetAddress1": "",
    "streetAddress2": "",
    "country": "",
    "state": "",
    "city": "",
    "zipCode": "",
    "engineSerialNo": "",
    "purchasedDate": "",
    "typeOfUse": "H",
    "amountOfUse": "",
    "stateSelectionType": "",
    "validForm": true,
    "timeZone": "",
    "formErrors": {
        "firstName": false,
        "lastName": false,
        "companyName": false,
        "emailAddress": false,
        "phone": false,
        "businessIndicator": false,
        "streetAddress1": false,
        "streetAddress2": false,
        "country": false,
        "state": false,
        "city": false,
        "zipCode": false,
        "engineSerialNo": false,
        "purchasedDate": false,
        "typeOfUse": false,
        "amountOfUse": false
    },
    "errors": [],
    "validationResponse": {
        "valid": Boolean,
        "validationMsg": String,
        "inputName": String
    }
}

const registrationRequestReducer = (state, action) => {
    if (action.type === "RESET_FORM_FIELDS") {
        return initialFormDetails;
    } else if (action.type === "HANDLE_INPUT_TEXT") {
        const result = {...state}
        result[action.field] = action.payload
        return result
    } else {
        return state;
    }
}

function RegistrationRequest(props) {

    let [formDetails, dispatch] = useReducer(registrationRequestReducer, initialFormDetails, undefined)
    useEffect(() => {
        props.resetForm()
        props.getCountries()

        return () => {
            dispatch({type: "RESET_FORM_FIELDS"})
        }
    }, []);

    const formDetailsChange = (e) => {

        dispatch({type: "HANDLE_INPUT_TEXT", field: e.target.name, payload: e.target.value})
    }

    const onSelectCountryDropdown = (e) => {
        formDetailsChange(e);
        let timeZoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone
        dispatch({type: "HANDLE_INPUT_TEXT", field: "timeZone", payload: timeZoneValue.toString()})
        dispatch({type: "HANDLE_INPUT_TEXT", field: "zipCode", payload: ""})
        console.log(formDetails)
        props.getStatesList(e.target.value, 'en_US')
        /*if(formDetails.formErrors && formDetails.formErrors.zipCode){
            formDetails.errors.splice(formDetails.errors.findIndex(a => a.inputName === "zipCode" && a.validationMsg === "Please select a Country."), 1)
            let postCodeError = formDetails.errors.filter(error => error.inputName === "zipCode")
            if(postCodeError.length === 0){
                let tempFormErr = {...formDetails.formErrors}
                tempFormErr.zipCode = false
                setFormDetails({
                    ...formDetails,
                    formErrors: tempFormErr
                })
            }
        }*/
    }

    const onSelectStateDropdown = (e) => {
        if (e.target.value !== "-1") {
            dispatch({type: "HANDLE_INPUT_TEXT", field: e.target.name, payload: e.target.value})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "stateSelectionType", payload: "select"})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "zipCode", payload: ""})
        } else {
            dispatch({type: "HANDLE_INPUT_TEXT", field: "state", payload: ""})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "stateSelectionType", payload: "select"})
        }
    }

    const onChangeStateInput = (e) => {
        if (e.target.value !== "") {
            dispatch({type: "HANDLE_INPUT_TEXT", field: e.target.name, payload: e.target.value})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "stateSelectionType", payload: "text"})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "zipCode", payload: ""})
        } else {
            dispatch({type: "HANDLE_INPUT_TEXT", field: "state", payload: ""})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "stateSelectionType", payload: "text"})
        }
    }

    const onBlurPinValidation = (e) => {
        if (e.target.value !== "") {
            const pinValidResp = props.validatePin(e.target.value);
            pinValidResp.then((resp) => {
                if (resp.data) {
                    const response = pinValidator(resp.data.data)
                    if (response) {
                        const validationResponseTemp = {
                            valid: response.valid,
                            validationMsg: response.validationMsg,
                            inputName: "engineSerialNo"
                        }

                        if (!response.valid) {
                            let formErrorsTemp = {...formDetails.formErrors};
                            formErrorsTemp["engineSerialNo"] = true

                            let errorsTemp = formDetails.errors
                            if (!errorsTemp.filter(vError => vError.inputName === "engineSerialNo")[0]) {
                                errorsTemp.push(validationResponseTemp)
                            } else {
                                errorsTemp.filter(vError => vError.inputName === "engineSerialNo")[0].valid = validationResponseTemp.valid
                                errorsTemp.filter(vError => vError.inputName === "engineSerialNo")[0].validationMsg = validationResponseTemp.validationMsg
                            }

                            dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                        } else {
                            //clear specific error
                            let formErrorsTemp = {...formDetails.formErrors};
                            formErrorsTemp["engineSerialNo"] = false
                            let errorsTemp = formDetails.errors
                            errorsTemp.splice(errorsTemp.findIndex(a => a.inputName === "engineSerialNo"), 1)
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                        }
                    } else {
                        const validationResponseTemp = {
                            valid: true,
                            validationMsg: ""
                        }

                        //clear specific error
                        let formErrorsTemp = {...formDetails.formErrors};
                        formErrorsTemp["engineSerialNo"] = false
                        let errorsTemp = formDetails.errors
                        errorsTemp.splice(errorsTemp.findIndex(err => err.inputName === "engineSerialNo"), 1)

                        dispatch({
                            type: "HANDLE_INPUT_TEXT",
                            field: "validationResponse",
                            payload: validationResponseTemp
                        })
                        dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                        dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                    }
                }
            })
        }
    }

    const handlePostalCodeValidation = (e) => {
        //Check Postal Code validation only if any of the Country is Selected And a state selected from the dropdown
        validateFormFields(e)
        if (formDetails.country && formDetails.stateSelectionType === "select" && (formDetails.zipCode.length >= 3 && formDetails.zipCode.length <= 15)) {
            const postalCodeData = {
                countryCode: formDetails.country,
                stateCode: formDetails.state,
                postalCode: e.target.value
            }
            const postalCodeResp = props.validatePostalCodeData(postalCodeData)
            postalCodeResp.then((resp) => {
                if (resp.data) {
                    const response = postalCodeApiValidator(formDetails, resp.data.data)
                    if (response) {
                        const validationResponseTemp = {
                            valid: response.valid,
                            validationMsg: response.validationMsg,
                            inputName: "zipCode"
                        }

                        if (!response.valid) {
                            let formErrorsTemp = {...formDetails.formErrors};
                            formErrorsTemp["zipCode"] = true

                            let errorsTemp = formDetails.errors
                            if (!errorsTemp.filter(vError => vError.inputName === "zipCode")[0]) {
                                errorsTemp.push(validationResponseTemp)
                            } else {
                                errorsTemp.filter(vError => vError.inputName === "zipCode")[0].valid = validationResponseTemp.valid
                                errorsTemp.filter(vError => vError.inputName === "zipCode")[0].validationMsg = validationResponseTemp.validationMsg
                            }
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                        } else {
                            //clear specific error
                            let formErrorsTemp = {...formDetails.formErrors};
                            formErrorsTemp["zipCode"] = false
                            let errorsTemp = formDetails.errors
                            errorsTemp.splice(errorsTemp.findIndex(a => a.inputName === "zipCode"), 1)

                            dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                            dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                        }
                    } else {
                        const validationResponseTemp = {
                            valid: true,
                            validationMsg: ""
                        }

                        //clear specific error
                        let formErrorsTemp = {...formDetails.formErrors};
                        formErrorsTemp["zipCode"] = false
                        let errorsTemp = formDetails.errors
                        errorsTemp.splice(errorsTemp.findIndex(err => err.inputName === "zipCode"), 1)

                        dispatch({
                            type: "HANDLE_INPUT_TEXT",
                            field: "validationResponse",
                            payload: validationResponseTemp
                        })
                        dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                        dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
                    }
                }
            })
        }
    }

    const submitFormDetailsRequest = (e) => {
        console.log(props)
        e.preventDefault()
        console.log(formDetails)
        props.submitRegistration(formDetails)
    }

    let countryItems = props.countriesDetail.countriesList.map((country) =>
        <option value={country.iso2CountryCode}>{country.countryShortName}</option>
    );

    let stateItems = props.statesDetail.statesList.map((state) =>
        <option value={state.stateCode}>{state.stateDesc}</option>
    );

    const validateFormFields = (e) => {
        let targetName = e.target.name;
        let response;

        switch (targetName) {
            case "amountOfUse" :
                response = amountOfUseValidator(formDetails, props)
                break;
            case "zipCode":
                response = postalCodeCountryValidator(formDetails)
                break;
            default:
                break;
        }

        if (response) {
            const validationResponseTemp = {
                valid: response.valid,
                validationMsg: response.validationMsg,
                inputName: e.target.name
            }

            if (!response.valid) {
                let formErrorsTemp = {...formDetails.formErrors};
                formErrorsTemp[e.target.name] = true

                let errorsTemp = formDetails.errors
                if (!errorsTemp.filter(vError => vError.inputName === e.target.name)[0]) {
                    errorsTemp.push(validationResponseTemp)
                } else {
                    errorsTemp.filter(vError => vError.inputName === e.target.name)[0].valid = validationResponseTemp.valid
                    errorsTemp.filter(vError => vError.inputName === e.target.name)[0].validationMsg = validationResponseTemp.validationMsg
                }

                dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
            } else {
                //clear specific error
                let formErrorsTemp = {...formDetails.formErrors};
                formErrorsTemp[e.target.name] = false
                let errorsTemp = formDetails.errors
                errorsTemp.splice(errorsTemp.findIndex(a => a.inputName === e.target.name), 1)

                dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
                dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
            }
        } else {
            const validationResponseTemp = {
                valid: true,
                validationMsg: ""
            }

            //clear specific error
            let formErrorsTemp = {...formDetails.formErrors};
            formErrorsTemp[e.target.name] = false
            let errorsTemp = formDetails.errors
            errorsTemp.splice(errorsTemp.findIndex(err => err.inputName === e.target.name), 1)

            dispatch({type: "HANDLE_INPUT_TEXT", field: "validationResponse", payload: validationResponseTemp})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "formErrors", payload: formErrorsTemp})
            dispatch({type: "HANDLE_INPUT_TEXT", field: "errors", payload: errorsTemp})
        }
        console.log("Form Field Validation:: FormErrors.size :  " + formDetails.errors.length)
        formDetails.errors.forEach(err1 => console.log(err1.valid + " " + err1.validationMsg + " " + err1.inputName))
    }

    const checkFormValidation = () => {

        let formError = formDetails.formErrors;
        const hasTrueKeysInFormErrors = formError !== undefined ?
            Object.keys(formError).some(key => formError[key]) : undefined;

        const hasApiValidationSuceess = (formDetails.state ?
            (props.postalCodeDetail
                && props.postalCodeDetail.postalCodeResp
                && props.postalCodeDetail.postalCodeResp.validPostalCd) : true)
            && props.pinValidationDetail
            && props.pinValidationDetail.pinValidationData
            && props.pinValidationDetail.pinValidationData.valid

        const requiredFieldsCommon = formDetails.streetAddress1
            && formDetails.country
            && formDetails.city
            && formDetails.engineSerialNo
        const requiredFieldsForState = (props.statesDetail.statesList.length > 0 && formDetails.state) || true
        const requiredFieldsForPurchaserType = formDetails.businessIndicator === "I" ?
            formDetails.firstName && formDetails.lastName : formDetails.companyName
        const requiredFieldSet = requiredFieldsCommon && requiredFieldsForPurchaserType && requiredFieldsForState
        return !(hasApiValidationSuceess && !hasTrueKeysInFormErrors && requiredFieldSet)
    }

    const loading = props.registrationDetail.loading

    const typeOfUseValue = [
        <option value='-1'>Please Select...</option>,
        <option value='H'>Hours</option>,
        <option value='M'>Miles</option>
    ]

    const onResetForm = (e) => {
        dispatch({type: "RESET_FORM_FIELDS"})
        console.log(formDetails.purchasedDate)
        console.log(formDetails.formErrors)
    }

    return (
        <div className="uxf-main-container" style={{paddingTop:'10px'}}>
            <Container fluid>
                <Row className="mb-2">
                    <Col className="cut-content-root-col">
                        <Card className="cut-card">
                            <h1 className="mb-3">CUT Registration</h1>
                            <Row>
                                <Col md="12" className='cut-card-img'>
                                    <img
                                        className="img-class"
                                        alt="CUT"
                                        src={CUTs_img}
                                    />
                                </Col>
                                <Col md="12" className='cut-card-text-wrapper'>
                                    <div className="cut-info-text"> If you have purchased your John Deere equipment through
                                        an outlet other than a John Deere dealer, we would like to connect with you and
                                        welcome you to the John Deere family! Register your equipment below and we will
                                        keep you up-to-date with helpful tips, ideas, and special offers.
                                    </div>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col md="24">
                                    {props.registrationDetail.registrationModelData.statusCode &&
                                    <Redirect to='/regSuccess'/>
                                    }
                                </Col>
                            </Row>

                            <fieldset disabled={loading}>
                                <Card.Body className="cut-card-body">
                                    <div>
                                        <h1 className="h3">Purchaser Information</h1>
                                        <Form id="basicForm" onSubmit={submitFormDetailsRequest}>
                                            <Row>
                                                <Col className="col-md-24 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="purchaseType">
                                                        <fieldset onChange={formDetailsChange}>
                                                            <legend>
                                                                Purchase Type{" "}
                                                                <span
                                                                    aria-label="required field"
                                                                    className="uxf-is-required"> *
												            </span>
                                                            </legend>

                                                            <Form.Check
                                                                custom
                                                                defaultChecked
                                                                label="Individual"
                                                                id="purchaseTypeId1"
                                                                type="radio"
                                                                name="businessIndicator"
                                                                value="I"
                                                                inline
                                                            />
                                                            <Form.Check
                                                                custom
                                                                label="Business"
                                                                id="purchaseTypeId"
                                                                type="radio"
                                                                name="businessIndicator"
                                                                value="B"
                                                                inline
                                                            />
                                                        </fieldset>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            {formDetails.businessIndicator === "I" ?
                                                <Row>
                                                    <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                        <Form.Group controlId="firstNameInp">
                                                            <Form.Label className="uxf-label">
                                                                First Name{" "}
                                                                <span
                                                                    aria-label="required field"
                                                                    className="uxf-is-required"
                                                                    required
                                                                >
                                                    *
                                                </span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                required placeholder=""
                                                                name="firstName"
                                                                className="invalid"
                                                                onChange={formDetailsChange} type="text"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                        <Form.Group controlId="lastNameInp">
                                                            <Form.Label className="uxf-label">
                                                                Last Name{" "}
                                                                <span
                                                                    aria-label="required field"
                                                                    className="uxf-is-required"
                                                                >
                                                                *
                                                            </span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                required
                                                                placeholder=""
                                                                name="lastName"
                                                                onChange={formDetailsChange} type="text"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row> :
                                                (
                                                    <div>
                                                        <Row>
                                                            <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                                <Form.Group controlId="companyNameInp">
                                                                    <Form.Label className="uxf-label">
                                                                        Company Name{" "}
                                                                        <span
                                                                            aria-label="required field"
                                                                            className="uxf-is-required">*
                                                                            </span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        required placeholder=""
                                                                        name="companyName"
                                                                        onChange={formDetailsChange} type="text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                                <Form.Group controlId="firstNameInp">
                                                                    <Form.Label className="uxf-label">
                                                                        First Name{" "}<span
                                                                        className="optional-text">(Optional)</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        placeholder=""
                                                                        name="firstName"
                                                                        className="invalid"
                                                                        onChange={formDetailsChange} type="text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                                <Form.Group controlId="lastNameInp">
                                                                    <Form.Label className="uxf-label">
                                                                        Last Name{" "}<span
                                                                        className="optional-text">(Optional)</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        placeholder=""
                                                                        name="lastName"
                                                                        onChange={formDetailsChange} type="text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )
                                            }

                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="emailAddressInp">
                                                        <Form.Label className="uxf-label">
                                                            Email {" "} <span className="optional-text">(required for special offer)</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            placeholder=""
                                                            name="emailAddress"
                                                            onChange={formDetailsChange}
                                                            type="email"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="phoneInp">
                                                        <Form.Label className="uxf-label">
                                                            Telephone{" "}<span
                                                            className="optional-text">(Optional)</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            placeholder=""
                                                            name="phone"
                                                            onChange={formDetailsChange}
                                                            type="text"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="streetAddress1Inp">
                                                        <Form.Label className="uxf-label" id="streetAddress1Lbl">
                                                            Street Address{" "}
                                                            <span
                                                                aria-label="required field"
                                                                className="uxf-is-required"
                                                            >
                                                                *
											                </span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            required type="text"
                                                            name='streetAddress1'
                                                            onChange={formDetailsChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="streetAddress2Inp">
                                                        <Form.Label
                                                            className="uxf-label"
                                                            id="streetAddress2Lbl">
                                                            Address Line 2{" "}<span
                                                            className="optional-text">(Optional)</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="streetAddress2"
                                                            onChange={formDetailsChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="countryInp">
                                                        <Form.Label className="uxf-label" id="countryDdLbl">
                                                            Country{" "}
                                                            <span
                                                                aria-label="required field"
                                                                className="uxf-is-required"
                                                            >
                                                            *
											            </span>
                                                        </Form.Label>
                                                        <Form.Control name="country" required custom as="select"
                                                                      onChange={onSelectCountryDropdown}
                                                        >
                                                            <option value='-1'>Please Select...</option>
                                                            {countryItems}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    {(formDetails.country && props.statesDetail.statesList.length > 0) ?
                                                        <Form.Group controlId="stateInp">
                                                            <Form.Label className="uxf-label" id="stateDdLbl">
                                                                State{" "}
                                                                <span
                                                                    aria-label="required field"
                                                                    className="uxf-is-required"
                                                                >*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                name="state"
                                                                required
                                                                custom as="select"
                                                                onBlur={onSelectStateDropdown}
                                                            >
                                                                <option value="-1">Please Select...</option>
                                                                {stateItems}
                                                            </Form.Control>
                                                            {(!formDetails.country && formDetails.state) &&
                                                            <span
                                                                className="inline-error-message">{"Please Select a Country."}</span>
                                                            }
                                                        </Form.Group> :
                                                        <Form.Group controlId="stateInp">
                                                            <Form.Label className="uxf-label" id="stateDdLbl">
                                                                State{" "}<span
                                                                className="optional-text">(Optional)</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="state"
                                                                onBlur={onChangeStateInput}/>
                                                            {(!formDetails.country && formDetails.state) &&
                                                            <span
                                                                className="inline-error-message">{"Please Select a Country."}</span>
                                                            }
                                                        </Form.Group>
                                                    }

                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="cityInp">
                                                        <Form.Label
                                                            className="uxf-label"
                                                            id="cityLbl"
                                                        >
                                                            City{" "}
                                                            <span
                                                                aria-label="required field"
                                                                className="uxf-is-required"
                                                            >*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name='city'
                                                            onChange={formDetailsChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                {props.statesDetail && props.statesDetail.statesList.length > 0 ?
                                                    <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                        <Form.Group controlId="zipcodeInp">
                                                            <Form.Label className="uxf-label" id="zipcodeLbl">
                                                                Zip/Postal Code{" "}
                                                                <span
                                                                    aria-label="required field"
                                                                    className="uxf-is-required"> *
											                </span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                required
                                                                name="zipCode"
                                                                type="text"
                                                                isInvalid={formDetails.formErrors && formDetails.formErrors["zipCode"]}
                                                                onChange={formDetailsChange}
                                                                onBlur={handlePostalCodeValidation}
                                                                value={formDetails.zipCode}
                                                            />
                                                            {
                                                                (formDetails.zipCode
                                                                    && formDetails.formErrors
                                                                    && formDetails.formErrors.zipCode) &&
                                                                <span className="inline-error-message">
                                                                {formDetails.errors.filter(error => error.inputName === "zipCode")[0].validationMsg}
                                                            </span>
                                                            }
                                                        </Form.Group>
                                                    </Col> :
                                                    <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                        <Form.Group controlId="zipcodeInp">
                                                            <Form.Label className="uxf-label" id="zipcodeLbl">
                                                                Zip/Postal Code{" "} <span
                                                                className="optional-text">(Optional)</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                name="zipCode"
                                                                type="text"
                                                                isInvalid={formDetails.formErrors && formDetails.formErrors["zipCode"]}
                                                                onChange={formDetailsChange}
                                                                onBlur={handlePostalCodeValidation}
                                                                value={formDetails.zipCode}
                                                            />
                                                            {
                                                                (formDetails.zipCode
                                                                    && formDetails.formErrors
                                                                    && formDetails.formErrors.zipCode) &&
                                                                <span className="inline-error-message">
                                                                    {formDetails.errors.filter(error => error.inputName === "zipCode")[0].validationMsg}
                                                                </span>
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                }
                                            </Row>
                                            <br/>
                                            <Row>
                                                <Col><h1 className="h3">Machine Information</h1></Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="engineSerialNoInp">
                                                        <Form.Label className="uxf-label" id="engineSerialNoLbl">
                                                            Product Identification/Serial Number
                                                            <span
                                                                aria-label="required field"
                                                                className="uxf-is-required"
                                                            >
                                                                *
											                </span>
                                                        </Form.Label>
                                                        <div>
                                                            {props.pinValidationDetail.loading ?
                                                                <Spinner accessibilityLabel="loading"
                                                                         className="uxf-spinner-border-sm"
                                                                         animation="border"/> :
                                                                <Form.Control
                                                                    required
                                                                    name="engineSerialNo"
                                                                    type="text"
                                                                    value={formDetails.engineSerialNo}
                                                                    isInvalid={formDetails.formErrors && formDetails.formErrors["engineSerialNo"]}
                                                                    onChange={formDetailsChange}
                                                                    onBlur={onBlurPinValidation}/>
                                                            }
                                                        </div>
                                                        {
                                                            <span className='inline-error-message'>
                                                            {(formDetails.engineSerialNo
                                                                && formDetails.formErrors
                                                                && formDetails.formErrors.engineSerialNo)
                                                            && formDetails.errors.filter(error => error.inputName === "engineSerialNo")[0].validationMsg}</span>
                                                        }
                                                        {/*{
                                                            <span className='inline-success-message'>{(formDetails.engineSerialNo && pinValidator(formDetails, props).valid) && pinValidator(formDetails, props).validationMsg}</span>
                                                        }*/}
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="purchasedDateInp">
                                                        <Form.Label className="uxf-label">
                                                            Purchased Date{" "}<span
                                                            className="optional-text">(Optional)</span>
                                                        </Form.Label>
                                                        <div className="uxf-date-picker">
                                                            <DatePicker className="form-control uxf-date-picker-input"
                                                                        selected={formDetails.purchasedDate}
                                                                        aria-label="date format: yyyy/MM/dd"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        onChange={
                                                                            date => dispatch({
                                                                                type: "HANDLE_INPUT_TEXT",
                                                                                field: "purchasedDate",
                                                                                payload: date
                                                                            })
                                                                        }
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="typeOfUseInp">
                                                        <Form.Label className="uxf-label" id="typeOfUseDdLbl">
                                                            Use Type{" "}
                                                        </Form.Label>
                                                        <Form.Control
                                                            name="typeOfUse"
                                                            required custom as="select"
                                                            onChange={formDetailsChange}
                                                            defaultValue={formDetails.typeOfUse}
                                                        >
                                                            {typeOfUseValue}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-12 col-lg-12 col-sm-24 col-24">
                                                    <Form.Group controlId="amountOfUseInp">
                                                        <Form.Label
                                                            className="uxf-label"
                                                            id="amountOfUseLbl"
                                                        >
                                                            Amount of Use{" "} <span
                                                            className="optional-text">(Optional)</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            name="amountOfUse"
                                                            type="text"
                                                            isInvalid={formDetails.formErrors && formDetails.formErrors["amountOfUse"]}
                                                            onChange={formDetailsChange}
                                                            onBlur={validateFormFields}
                                                        />
                                                        {
                                                            <span
                                                                className="inline-error-message">
                                                                {(formDetails.amountOfUse
                                                                    && formDetails.formErrors
                                                                    && formDetails.formErrors.amountOfUse)
                                                                && formDetails.errors.filter(error => error.inputName === "amountOfUse")[0].validationMsg}
                                                            </span>
                                                        }
                                                        {/*{
                                                        <span className="inline-error-message">{(formDetails.amountOfUse
                                                            && amountOfUseValidator(formDetails, props)
                                                            && !amountOfUseValidator(formDetails, props).valid)
                                                        && amountOfUseValidator(formDetails, props).validationMsg}</span>
                                                    }*/}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <div className="mx-auto">
                                                    <Button
                                                        className="mt-2"
                                                        type="reset"
                                                        onClick={onResetForm}
                                                    >
                                                        Clear
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        className="mt-2 btn"
                                                        type="submit"
                                                        disabled={checkFormValidation()}
                                                    >
                                                        Submit
                                                    </Button>
                                                </div>
                                            </Row>
                                        </Form>
                                    </div>
                                </Card.Body>
                            </fieldset>

                            {loading ?
                                <div className="loader-container">
                                    <div className="loader">
                                        <Spinner accessibilitylabel="Loading" animation="border"/>
                                    </div>
                                </div> : null
                            }

                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default connect(mapStateToProp, mapDispatchToProps)(RegistrationRequest);

